module.exports = __webpack_public_path__ + "9a83a45a9cb7e156abf7975bf34e0a1c.woff";


//////////////////
// WEBPACK FOOTER
// ./~/ui-text-editor/src/fonts/3dprint.woff?hntrwn
// module id = 404
// module chunks = 0